// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_n3-2";
export var interactiveWrapper = "_n3-0";
export var shippingHoverPreview = "_n3-4";
export var summaryBadgeTrigger = "_n3-1";
export var widgetHoverPreviewList = "_n3-3";
export var widgetPreviewScale = "_n3-5";